import { WorkTypes } from '@foxeet/domain';
import { PATHS } from '@foxeet/n-core';

export class WorkTypesUtils {
  static getWorkTypeURLPath(workType: WorkTypes) {
    const paths = new Map([
      [WorkTypes.Appraisal, PATHS.APPRAISALS],
      [WorkTypes.AdditionalOrders, PATHS.MANAGEMENT_ORDERS],
      [WorkTypes.QualityControl, PATHS.QUALITY_CONTROL],
    ]);

    return paths.get(workType);
  }

  static getWorkTypeByURLPath(path: string) {
    const workTypes = new Map([
      [PATHS.APPRAISALS, WorkTypes.Appraisal],
      [PATHS.MANAGEMENT_ORDERS, WorkTypes.AdditionalOrders],
      [PATHS.QUALITY_CONTROL, WorkTypes.QualityControl],
    ]);

    return workTypes.get(path);
  }
}
